const CALENDLY_LINK = 'https://calendly.com/paul-cleocremation/30min';

export const getAftercareEmailSubject = (language: 'en' | 'fr' | undefined): string =>
  language === 'fr' ? 'Des nouvelles de Cleo' : 'Checking in from Cleo';

export const getDefaultAftercareMessage = (
  language: 'en' | 'fr' | undefined,
  firstName: string,
): string => {
  if (language === 'fr') {
    const greeting = firstName ? `Bonjour ${firstName},` : 'Bonjour,';
    return `${greeting}

J'espère que vous allez bien ces derniers jours.

Comme promis, nous sommes toujours là pour vous accompagner dans les prochaines étapes.

Je m'appelle Paul — je travaille avec l'équipe Cleo sur le volet aftercare, pour aider les familles à traverser les semaines qui suivent la crémation. Si cela peut vous être utile, je suis disponible pour discuter de choses comme :

- rédiger une nécrologie ou un avis de décès
- organiser une célébration de vie
- traverser le deuil, et trouver du soutien pour vous accompagner
- ou simplement comprendre ce qui demande généralement votre attention (et ce qui peut attendre)

Je prévois de vous appeler d'ici quelques jours. Si un autre moment vous convient mieux, n'hésitez pas à répondre à ce message ou à réserver directement un créneau : ${CALENDLY_LINK}

Aucune pression — je suis là si et quand vous en avez besoin.

Chaleureusement,
Paul
Cleo`;
  }

  const greeting = firstName ? `Hi ${firstName},` : 'Hi,';
  return `${greeting}

I hope you've been doing okay these past few days.

As promised, we continue to be here to support you with anything that comes next.

My name is Paul — I work with the Cleo team on aftercare, helping families navigate the weeks following the cremation. If it would be helpful, I'm available to talk through things like:

- writing an obituary or announcement
- planning a celebration of life
- navigating grief, and finding support to help you through it
- or simply understanding what typically needs attention (and what can wait)

I'll plan to give you a call in a couple of days. If there's a time that works better for you, feel free to reply here or book a time directly: ${CALENDLY_LINK}

No pressure at all — just here if and when you need.

Warmly,
Paul
Cleo`;
};
